export default __webpack_public_path__ + "static/media/about-greeting-7.55f348a9.png";